"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
var layout_1 = __importDefault(require("./layout"));
var global_1 = __importDefault(require("./global"));
var siteGroups_1 = __importDefault(require("./siteGroups"));
var siteSection_1 = __importDefault(require("./siteSection"));
var errorPage_1 = __importDefault(require("./errorPage"));
var hero_1 = __importDefault(require("./hero"));
var notificationBanner_1 = __importDefault(require("./notificationBanner"));
var footer_1 = __importDefault(require("./footer"));
var versionSelector_1 = __importDefault(require("./versionSelector"));
var navTree_1 = __importDefault(require("./navTree"));
var navPopover_1 = __importDefault(require("./navPopover"));
var social_1 = __importDefault(require("./social"));
var appBar_1 = __importDefault(require("./appBar"));
var portalPopover_1 = __importDefault(require("./portalPopover"));
var portalBreadcrumb_1 = __importDefault(require("./portalBreadcrumb"));
var searchBox_1 = __importDefault(require("./searchBox"));
var prettyprint_1 = __importDefault(require("./prettyprint"));
var nprogress_1 = __importDefault(require("./nprogress"));
var prettyprint_2 = __importDefault(require("./prettyprint"));
var searchIndex_1 = __importDefault(require("./searchIndex"));
var upgradeBrowser_1 = __importDefault(require("./upgradeBrowser"));
var login_1 = __importDefault(require("./login"));
var logout_1 = __importDefault(require("./logout"));
var portalTabs_1 = __importDefault(require("./portalTabs"));
var indexPage_1 = __importDefault(require("./indexPage"));
var contentPage_1 = __importDefault(require("./contentPage"));
var showContents_1 = __importDefault(require("./showContents"));
var sectionItem_1 = __importDefault(require("./sectionItem"));
var metadata_1 = __importDefault(require("./metadata"));
var searchResultItem_1 = __importDefault(require("./searchResultItem"));
var searchResultList_1 = __importDefault(require("./searchResultList"));
var implicitNull = function () { return function (a, b) { return b == null ? a : deepmerge_1.default(a, b, { customMerge: implicitNull }); }; };
var baseFonts = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
var baseTheme = function (breakpoints) {
    var _a, _b, _c;
    var MAX_S = breakpoints.MAX_S, MIN_S = breakpoints.MIN_S, MAX_XL = breakpoints.MAX_XL, MEDIA_PRINT = breakpoints.MEDIA_PRINT;
    var base = {
        typography: {
            fontFamily: baseFonts
        },
        overrides: {
            MuiCssBaseline: deepmerge_1.default.all([
                global_1.default(breakpoints),
                {
                    //This is defined here simply because it is the same as the typography setting
                    // it's easier to maintain in one place
                    "@global": {
                        ":root": {
                            "--mdc-typography-font-family": baseFonts
                        }
                    }
                },
                prettyprint_2.default(breakpoints),
                nprogress_1.default(breakpoints)
            ], { customMerge: implicitNull }),
            MuiLink: {
                root: {
                    textDecoration: 'none',
                    color: 'inherit'
                }
            },
            MuiTab: {
                root: {
                    '@media (min-width: 600px)': {
                        minWidth: "initial"
                    }
                }
            }
        },
        hidePrint: (_a = {},
            _a[MEDIA_PRINT] = {
                display: "none !important",
            },
            _a),
        relatedLinksTitle: {
            fontWeight: "bold",
        },
        relatedLinks: (_b = {
                padding: "0 2rem 0 0"
            },
            _b[MAX_XL] = {
                padding: "0 2rem 0 0",
            },
            _b[MAX_S] = {
                padding: "0 2rem 0 0",
            },
            _b.marginTop = "2rem",
            _b),
        linkAccordionDetails: {
            flexDirection: "column"
        },
        linkAccordionSummary: {
            marginTop: "10px",
        },
        linkAccordion: {
            boxShadow: "none",
            "&::before": {
                display: "none",
            }
        },
        portalLink: {
            textDecoration: "none",
            "&::hover": {
                textDecoration: "none",
            }
        },
        simpleTreeItem: {
            "& a > p": {
                fontSize: "0.875rem",
                textTransform: "capitalize",
                padding: "0.25rem"
            }
        },
        simpleTreeItemSelected: {},
        stepLinkIcon: {
            display: "flex",
            "& .material-icons": (_c = {},
                _c[MIN_S] = {
                    marginLeft: "2rem"
                },
                _c.fontSize = "2.1875rem !important",
                _c)
        },
        stepLinks: {
            flex: 1,
            display: 'flex',
            flexDirection: "row",
            justifyContent: "flex-end",
        },
        stepLinksTop: {},
    };
    return deepmerge_1.default.all([
        base,
        appBar_1.default(breakpoints),
        contentPage_1.default(breakpoints),
        errorPage_1.default(breakpoints),
        footer_1.default(breakpoints),
        hero_1.default(breakpoints),
        indexPage_1.default(breakpoints),
        layout_1.default(breakpoints),
        login_1.default(breakpoints),
        logout_1.default(breakpoints),
        metadata_1.default(breakpoints),
        navPopover_1.default(breakpoints),
        navTree_1.default(breakpoints),
        notificationBanner_1.default(breakpoints),
        nprogress_1.default(breakpoints),
        portalBreadcrumb_1.default(breakpoints),
        portalPopover_1.default(breakpoints),
        portalTabs_1.default(breakpoints),
        prettyprint_1.default(breakpoints),
        searchIndex_1.default(breakpoints),
        searchBox_1.default(breakpoints),
        searchResultItem_1.default(breakpoints),
        searchResultList_1.default(breakpoints),
        sectionItem_1.default(breakpoints),
        showContents_1.default(breakpoints),
        siteGroups_1.default(breakpoints),
        siteSection_1.default(breakpoints),
        social_1.default(breakpoints),
        versionSelector_1.default(breakpoints),
        upgradeBrowser_1.default(breakpoints),
    ]);
};
exports.default = baseTheme;
//# sourceMappingURL=index.js.map